/**
 * CUSTOMER DASHBOARD - FIGMA DESIGN INTEGRATION
 * 
 * This dashboard integrates the complete Figma design for Virewire with a modern,
 * professional layout including sidebar navigation, top nav, and comprehensive
 * content sections for property management.
 * 
 * Features:
 * - Complete sidebar navigation with 10 main sections
 * - Top navigation bar with support info and user profile
 * - Welcome section with property onboarding
 * - 4-column metrics grid for key KPIs
 * - Action required panel for urgent tasks
 * - Active orders table with progress tracking
 * - Recent quotes grid with approval/payment actions
 * - Quick actions sidebar
 * - Properties list
 * - Recent activity timeline
 * - Quick wallet teaser card
 */

import { Helmet } from 'react-helmet-async';
import CustomerDashboard from '@/components/dashboard/CustomerDashboard';

const Dashboard = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard | Virewire Property Services</title>
        <meta name="description" content="Manage your properties, orders, quotes, and invoices in your Virewire customer dashboard." />
      </Helmet>

      <CustomerDashboard />
    </>
  );
};

export default Dashboard;
